import numeral from 'numeral'

export const fmtNumber = new Intl.NumberFormat('en-US', {
  maximumSignificantDigits: 2,
})

export const parseNumber = (str: string) => Number(str.replace(/[^0-9.-]+/g, ''))

export const fmtCurrency = (val: number | string) => {
  if (typeof val === 'string') val = parseNumber(val)
  return val.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  })
}

export function prettyInteger(val: number | string): string {
  return numeral(val).format('0,0')
}
